import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { Grid, Typography } from "@material-ui/core";
import { Formik, Form } from "formik";
import * as Yup from "yup";

import FormikControl from "@Components/FormikControl/FormikControl.js";
import { Button } from "@material-ui/core";
import useStyles from "@Views/Styles/LoginStyles";
import { useAuth } from "@Views/Authentication/AuthContext";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import { LOGIN_VERIFY_URL, STORAGE_CONSTANT, URLS } from "configs/constants";
import FGVLogo from "assets/img/fgv-logo.png";
import eightAxios from "configs/axiosConfig";
import { getRedirectUrl } from "utils";

const Login = () => {
  const [validId, setValidId] = useState(false);
  const [otpPage, setOtpPage] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const classes = useStyles();

  let initialValues = {
    employee_id: "",
  };

  const { authLoading, loggedIn, logout } = useAuth();

  const onSubmit = (values) => {
    setLoading(true);
    eightAxios
      .post(LOGIN_VERIFY_URL, values)
      .then((response) => {
        if (response.status === 202) {
          setEmployeeId(values.employee_id);
          setMobileNumber(response.data.mobile_number);
          setValidId(true);
          setLoading(false);
          localStorage.setItem(STORAGE_CONSTANT.ID, response.data.employee_pk);
        }
        if (response.status === 200) {
          setEmployeeId(values.employee_id);
          setMobileNumber(response.data.mobile_number);
          setValidId(true);
          setOtpPage(true);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          setErrorMsg(error.response.data.message);
          //   location.reload();
        } else {
          setErrorMsg(error.message);
          //   location.reload();
        }
        setValidId(false);
      });
  };

  const validationSchema = Yup.object({
    employee_id: Yup.string().required("Employee ID Required*"),
  });

  if (loggedIn) {
    let redirectUrl = getRedirectUrl();
    if (redirectUrl) return <Redirect to={redirectUrl} />;
    setErrorMsg("User doesn't have any module/s assigned.");
    logout();
  }

  if (loading) {
    return <LoadingIcon image text="Loading" />;
  }

  if (validId) {
    if (otpPage) {
      return (
        <Redirect
          to={{
            pathname: URLS.LOGIN_OTP,
            state: { employee_id: employeeId, mobile_number: mobileNumber },
          }}
        />
      );
    }
    return (
      <Redirect
        to={{
          pathname: URLS.LOGIN_PASSWORD,
          state: { employee_id: employeeId, mobile_number: mobileNumber },
        }}
      />
    );
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {!authLoading ? (
        (formik) => {
          return (
            <Form style={{ width: "100%" }}>
              <Grid
                className={classes.root}
                container
                spacing={2}
                direction="column"
                alignItems="center"
                justify="center"
              >
                <Grid item xs={10} sm={6} lg={3}>
                  <img src={FGVLogo} alt="FGV" width={200} />
                </Grid>
                <Grid item xs={10} sm={6} lg={3}>
                  <Typography variant="h4">LOGIN</Typography>
                </Grid>

                <Grid className={classes.grid} item xs={10} sm={6} lg={3}>
                  <FormikControl
                    control="input"
                    variant="outlined"
                    name="employee_id"
                    fullWidth
                    size="small"
                    label="Employee ID"
                  />
                  <Grid item>
                    <Typography
                      align="center"
                      variant="subtitle1"
                      color="error"
                    >
                      {errorMsg.length ? errorMsg : errorMsg}
                    </Typography>
                  </Grid>

                  <Button
                    type="submit"
                    disabled={!formik.isValid || authLoading}
                    variant="contained"
                    color="primary"
                    fullWidth
                  >
                    login
                  </Button>
                </Grid>
              </Grid>
            </Form>
          );
        }
      ) : (
        <LoadingIcon image text="Logging in" />
      )}
    </Formik>
  );
};
export default Login;
